module.exports = __webpack_public_path__ + "static/img/334X156.c04e562a.jpg";